import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import './CookieConsent.css';

const COOKIE_CONSENT_KEY = 'mpb_cookie_consent';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="cookie-icon"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <p className="mb-0">
            <strong>Cookie Notice:</strong> This website uses only essential cookies and browser storage necessary for
            website functionality (session authentication, form security, and remembering your preferences within admin
            tools). No tracking cookies, analytics, or advertising services are used. The Impact Map loads map imagery
            from Esri and OpenStreetMap. See our <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
        <Button
          variant="primary"
          size="sm"
          onClick={handleAccept}
          className="cookie-consent-button"
        >
          Got it
        </Button>
      </div>
    </div>
  );
}

export default CookieConsent;
